const serverConfig = {
    //serverUrl: `${process.env.REACT_APP_BACKEND_URL}`
    //serverUrl: 'http://192.168.3.161:8080'

    // da utilizzare per caricarla su arubba
    serverUrl: 'https://www.spettrometriadimassa.org/api/index.php'
};
  
export default serverConfig;